import { useContext } from 'react';
import { createContext } from 'react';

import { ProductQuantityProps } from '../@types/ProductQuantityProps';

export const ProductQuantityContext = createContext<ProductQuantityProps>({} as ProductQuantityProps);

ProductQuantityContext.displayName = 'ProductQuantity';

const ProductQuantityProvider = (props: ProductQuantityProps) => (
	<ProductQuantityContext.Provider value={props}>{props.children}</ProductQuantityContext.Provider>
);

export const useProductQuantity = () => {
	const context = useContext(ProductQuantityContext);

	return context;
};

export default ProductQuantityProvider;
